import { render, staticRenderFns } from "./create_room.vue?vue&type=template&id=2055c9f6&scoped=true&"
import script from "./create_room.vue?vue&type=script&lang=js&"
export * from "./create_room.vue?vue&type=script&lang=js&"
import style0 from "./create_room.vue?vue&type=style&index=0&id=2055c9f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2055c9f6",
  null
  
)

export default component.exports